import React, { useEffect, useState, Fragment } from 'react';
import { 
  Container,
  Grid,
  makeStyles,
  Hidden,
} from '@material-ui/core';
import { 
  BackNavAdmin,
  IdeaGeneral,
  IdeaExecution,
  IdeaConclusion,
  IdeaQualification,
  IdeaQualificationTabs,
  IdeaResults,
  IdeaEngagement
} from '../../components';
import { SidebarIdeaPoint, CustomSelect } from '../../components';
import { useSelector, useDispatch } from 'react-redux';
import { ideaActions } from '../../actions';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import { optionConstants } from '../../constants';
import { useTranslation } from 'react-i18next';
import { searchToObject } from "./../../helpers"

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      paddingRight: 14,
    },
  },
}));

export const IdeaDetailsPage = () => {
  const classes = useStyles();
  const history = useHistory()
  const dispatch = useDispatch();
  const location = useLocation();
  const { id, page } = useParams();
  const { t } = useTranslation();
  const { ideaDetails } = useSelector((state) => state.idea);
  const { typeProfile } = useSelector((state) => state.user);

  useEffect(() => {
    if(['general', 'qualification', 'execution', 'conclusion', 'results', 'engagement'].includes(page)) {
      if (!ideaDetails._id || ideaDetails._id !== id) {
        dispatch(ideaActions.getIdeaDetails(id));
      }
    } else {
      history.goBack();
    }
  }, [page, id]);

  useEffect(() => {
    return () => dispatch(ideaActions.clearIdeaDetails());
  }, [dispatch]);

  return (
    <>
      <BackNavAdmin title={ideaDetails.name} />
      <Container maxWidth="lg" className={classes.root}>
        <Grid container spacing={4}>
          <Hidden smDown>
            <Grid item xs={3}>
              {ideaDetails?.statusIdea?.code && (
                <SidebarIdeaPoint />
              )}
            </Grid>
          </Hidden>
          <Hidden smUp>
            <Grid item xs={12}>
              <CustomSelect
                optionsAvaiable={[
                  optionConstants.IDEA,
                  optionConstants.QUALIFICATION,
                ]}
                startOption={optionConstants.IDEA}
              />
            </Grid>
          </Hidden>
          <Grid item xs={12} md={9}>
            { page && (
              <Fragment>
                { page === "general" && ideaDetails._id && (
                  <IdeaGeneral />
                )} 

                { page === "qualification" && ideaDetails._id && (
                  <Fragment>
                    {(typeProfile.type === 'admin' || typeProfile.type === 'manager') && 
                    ideaDetails.statusIdea?.code === 'AWAITING_QUALIFICATION' ? (
                      <Grid container spacing={4}>
                        <Grid item xs={12}>
                          <IdeaQualificationTabs />
                        </Grid>
                      </Grid>
                    ) : (
                      <IdeaQualification 
                        idea={ideaDetails} 
                        createdAt={ideaDetails.createdAt}
                        approveDate={ideaDetails.approveDate}
                      />
                    )}
                  </Fragment>
                )} 

                { page === "execution" && ideaDetails._id && (
                  <IdeaExecution />
                )} 

                { page === "conclusion" && ideaDetails._id && (
                  <IdeaConclusion />
                )} 

                { page === "results" && ideaDetails._id && (
                  <IdeaResults />
                ) }

                { page === "engagement" && ideaDetails._id && (
                  <IdeaEngagement />
                )} 
              </Fragment>
            )}
          </Grid>
        </Grid>
      </Container>
    </>
  )
}
